var slickInstance;

App.prototype.buildProductDetailModal = function (data, productUid) {
    var modal = $('.product-detail-modal'),
        slickSlider = modal.find('.product-detail-slider'),
        submitButton = modal.find('button[type=submit]:not(.buy-now)'),
        buyNowButton = modal.find('.buy-now'),
        shopierButton = modal.find('.btn-shopier');

    modal.find('h4').text(App.prototype.translateAttribute(data.name));

    if (data.description && App.prototype.translateAttribute(data.description) !== null) {

        modal.find('.description-wrapper').html('<div class="description">' + App.prototype.translateAttribute(data.description) + '</div>');

    }else{

        modal.find('.description-wrapper').html('');

    }

    modal.find('.count').val(1);
    modal.find('.quantity-input').val(1);
    modal.find('.price').html(data.is_price_visible ? App.prototype.currencyFormat(data.price) + ' ' + translates.currency_code : '')

    modal.find('#productDescriptions').html('');

    if (data.is_price_visible){
        modal.find('.product-actions').removeClass('d-none');
        modal.find('button[type=submit]').removeClass('d-none');
    }else{
        modal.find('.product-actions').addClass('d-none');
        modal.find('button[type=submit]').addClass('d-none');
    }

    if (data.is_price_hidden_from_guest){
        modal.find('.price-is-hidden-message').removeClass('d-none');
    }else{
        modal.find('.price-is-hidden-message').addClass('d-none');
    }

    var el_getOfferModalButton = $('[data-show-product-get-offer-modal]');
    if(data.is_product_get_offer_available){
        el_getOfferModalButton.removeClass('d-none');

        el_getOfferModalButton
            .attr('data-show-product-get-offer-modal', data.unique_id)
            .attr('data-product-name', App.prototype.translateAttribute(data.name));
    }else{
        el_getOfferModalButton.addClass('d-none');
    }

    if (data.product_descriptions !== 'undefined'){

        for (const productDescriptionsKey in data.product_descriptions) {

            modal.find('#productDescriptions').append(data.product_descriptions[productDescriptionsKey].text);

        }

    }

    modal.find('#campaignMessage').html('');

    if (data.campaign_message){

        modal.find('#campaignMessage').html(`<div class="alert alert-warning">${data.campaign_message}</div>`);

    }

    if (data.discounted_price) {
        modal.find('.normal-price').html(data.is_price_visible ? App.prototype.currencyFormat(data.normal_price) + ' ' + translates.currency_code : '');
        modal.find('.discount-percentage').html(data.is_price_visible ? '%' + Math.ceil(((data.normal_price - data.price) / data.normal_price) * 100) : '');
    } else {
        modal.find('.discount-percentage').html('');
        modal.find('.normal-price').html('');
    }

    if (slickInstance) {

        slickInstance.slick('unslick');

    }

    if (data.images) {

        if (data.images.length){
            var slidesHtml = '';

            data.images.forEach(function (item) {
                slidesHtml += '<div class="slide"><a href="' + item.url + '" data-fancybox="gallery"><img src="' + item.url + '" alt="' + App.prototype.translateAttribute(data.name) + '"><span class="enlarge-handle"><img src="/assets/consumer/default/img/icons/search.svg" alt=""></span></a></div>';
            });

            slickSlider.html(slidesHtml);
        }else{
            var placeholder = '<div class="slide"><div class="image-placeholder-for-slider"><span>'+translates.product_no_image+'</span></div></div>';

            slickSlider.html(placeholder);
        }
    }

    var features = data.features;
    var selectionsHolder = modal.find('.feature-selections');
    selectionsHolder.empty();
    App.prototype.selectedProductUi = productUid;
    modal.find('.product-uid-input').val(productUid);
    features.forEach(function (item) {
        if (item.type === "choose_one") {
            App.prototype.selectedProductType = "choose_one";
            App.prototype.buildSelect(item, selectionsHolder);
        } else if (item.type === "multiple") {
            App.prototype.selectedProductType = "multiple";
            App.prototype.buildCheckbox(item, selectionsHolder);
        }
    });

    if (data.parent_id === null){

        var variation_tree = data.variation_tree;
        var variantsHolder = modal.find('.variations');
        variantsHolder.empty();

        App.prototype.buildVariationTree(variantsHolder, variation_tree, data);

    }

    var orderInputs = data.product_order_inputs;
    var orderInputsHolder = modal.find('.order-inputs');
    orderInputsHolder.empty();

    orderInputs.forEach(function (item) {

        App.prototype.buildOrderInput(item, orderInputsHolder);

    });

    setTimeout(function(){
        slickInstance = slickSlider.slick({
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            slide: '.slide',
            arrows: false,
            dots: true,
        });
    }, 150)

    var el_whatsapp_input = modal.find('.send-with-whatsapp [data-first-part]');
    if (el_whatsapp_input.length) {
        var firstText = el_whatsapp_input.data('firstPart');

        el_whatsapp_input.val(firstText + ' ' + data.url);
    }

    if (data.is_active && data.stock === 0){

        submitButton.attr('data-out-of-stock', true);

    }else{

        submitButton.removeAttr('data-out-of-stock', false);

    }

    if (data.is_active && data.stock !== 0){

        submitButton.prop("disabled", false);

    }else{

        submitButton.prop("disabled", true);

    }

    if (data.remote_id && shopierButton.length){

        shopierButton.attr("href", shopierButton.data("hrefBase") + data.remote_id)
        shopierButton.show();

    }else{

        shopierButton.hide();

    }
}
